// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 488) return "js/js/tinymce.js";
	if (chunkId === 178) return "js/js/d3.js";
	if (chunkId === 48) return "js/js/charts/radar-chart.js";
	// return url for filenames based on template
	return undefined;
};